import axios from 'axios'
import qs from 'qs'
import { Message, MessageBox } from 'element-ui'
import { getToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // 完全依赖环境变量，不设置默认值
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 500000, // request timeout
  paramsSerializer(params) {
    return qs.stringify(params, {
      arrayFormat: 'repeat'
    })
  }
})
// request interceptor
service.interceptors.request.use(
  config => {
    // console.log('=== REQUEST INTERCEPTOR ===');
    // console.log('Request URL:', config.url);
    // console.log('Full URL:', config.baseURL + config.url);
    // console.log('Request method:', config.method);
    // console.log('Request headers:', config.headers);

    if (Object.prototype.toString.call(config.data) == "[object Object]" && config.isFormData) {
      var list = [];
      let obj = config.data
      for (var key in obj) {
        if (obj[key] !== undefined && obj[key] !== null) {
          list.push(`${key}=${encodeURIComponent(obj[key])}`)
        }
      }
      let str = list.join("&")
      config.data = str
     // console.log('FormData converted to:', str);
    }

    if (getToken()) {
      // 让每个请求携带token-- ['Authorization']为自定义key 请根据实际情况自行修改
      config.headers['Token'] = 'DU ' + getToken()
    }
    
    // console.log('Final request config:', config);
    //console.log('🚀 SENDING REQUEST TO NETWORK 🚀');
    return config
  },
  error => {
    // Do something with request error
    Promise.reject(error)
  }
)
// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    // 如果是blob响应或跳过拦截器，直接返回
    if (response.config.skipInterceptor || response.config.responseType === 'blob') {
      return response
    }
    
    const data = response.data
    if (response.status >= 200 && response.status < 300) {
      // 处理 UNAUTHORIZED_LOGIN 错误（使用 errorCode 格式）
      if (data.errorCode === 'UNAUTHORIZED_LOGIN' || 
          (data.success === false && data.errorCode && data.errorCode.includes('UNAUTHORIZED'))) {
        // 检查是否是登录相关的请求，避免在登录过程中显示过期提示
        const isLoginRequest = response.config.url && (
          response.config.url.includes('/login') || 
          response.config.url.includes('/_user/login')
        );
        
        if (!isLoginRequest) {
          const errorMsg = data.errorMessage || data.message || '用户会话数据异常，请重新登录！'
          MessageBox.alert(errorMsg, '错误', {
            confirmButtonText: '确定',
            type: 'error'
          }).then(() => {
            removeToken() // must remove  token  first
            resetRouter()
            location.reload()
          })
        }
        return Promise.reject('error')
      }
      // 处理原有的 code 格式错误
      if (data.code === '-2' || data.code === '-7') {
        // 检查是否是登录相关的请求，避免在登录过程中显示过期提示
        const isLoginRequest = response.config.url && (
          response.config.url.includes('/login') || 
          response.config.url.includes('/_user/login')
        );
        
        if (!isLoginRequest) {
          MessageBox.alert('登录已过期请重新登录！', '错误', {
            confirmButtonText: '确定',
            type: 'error'
          }).then(() => {
            removeToken() // must remove  token  first
            resetRouter()
            location.reload()
          })
        }
        return Promise.reject('error')
      } else if (response.config.silent && (data.success === false || data.code === '-1')) {
        // BUG-2026-994011：调用方自己展示错误（如活动表单持续错误框），这里不弹提示，把原始响应交回去
        const failure = new Error(data.errorMessage || data.message || '保存失败')
        failure.response = response
        failure.config = response.config
        return Promise.reject(failure)
      } else if (data.code === '-1') {
        Message({ message: data.message, type: 'error' })
        return Promise.reject('error')
      } else {
        return data
      }
    } else {
      return Promise.reject(new Error(data))
    }
  },
  error => {
    console.error('Request error:', error);
    console.error('Error response:', error.response);
    
    let message = error.message || '网络请求失败'
    
    if (error.response) {
      // 服务器响应了错误状态码
      const { status, data } = error.response
      console.error('Response status:', status);
      console.error('Response data:', data);
      
      if (data && data.message) {
        message = data.message
      } else if (status === 404) {
        message = '请求的资源不存在'
      } else if (status === 500) {
        message = '服务器内部错误'
      } else if (status === 403) {
        message = '没有权限访问'
      } else {
        message = `请求失败 (${status})`
      }
    } else if (error.request) {
      // 请求已发出但没有收到响应
      console.error('No response received:', error.request);
      message = '网络连接失败，请检查网络'
    } else {
      // 其他错误
      console.error('Request setup error:', error.message);
    }
    
    // config.silent：调用方自己负责展示错误（例如活动规则冲突要把多行冲突明细
    // 用弹窗排版展示，单行 toast 根本读不清）。默认行为不变。
    if (!error.config || !error.config.silent) {
      Message({
        message: message,
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service
